import logoDark from '../../../assets/ui/logo.png';
import logoLight from '../../../assets/svg/logo_w.svg?url';

interface LogoProps {
  variant?: 'light' | 'dark';
  className?: string;
}

const Logo: React.FC<LogoProps> = ({ variant = 'light', className }) => {
  const src = variant === 'dark' ? logoDark : logoLight;
  return <img src={src} alt="La Piazza" className={className} />;
};

export default Logo;
